import {useMutation} from '@apollo/react-hooks';

import type {
    DuplicateEmailSequenceTemplate as EmailSequenceTemplateDuplicateMutation,
    DuplicateEmailSequenceTemplateVariables as DuplicateEmailSequenceTemplateMutationVariables,
    EmailSequenceTemplateDuplicateInput,
} from 'nutshell-graphql-types';

import DUPLICATE_EMAIL_SEQUENCE_TEMPLATE from '../mutations/duplicate-email-sequence-template.graphql';

export function useDuplicateEmailSequenceTemplate(): {
    duplicateEmailSequenceTemplate: (arg1: EmailSequenceTemplateDuplicateInput) => Promise<any>;
    isLoading: boolean;
} {
    const [duplicateEmailSequenceTemplate, {loading}] = useMutation<
        EmailSequenceTemplateDuplicateMutation,
        DuplicateEmailSequenceTemplateMutationVariables
    >(DUPLICATE_EMAIL_SEQUENCE_TEMPLATE);

    return {
        duplicateEmailSequenceTemplate: (input: EmailSequenceTemplateDuplicateInput) =>
            duplicateEmailSequenceTemplate({
                variables: {input: input},
            }),
        isLoading: loading,
    };
}
